import { TrafficGaugeStatus } from '../../../external-dependencies/webapp-utils';

type Props = {
  coverage: number;
};

export function GaugeChart({ coverage }: Props): JSX.Element {
  return (
    <TrafficGaugeStatus
      coveragePercentage={coverage}
      isHighlighted={false}
      isCoverageMeasureComplete
    />
  );
}
